module.exports = __webpack_public_path__ + "img/freewave1_05.e6bc57e2.jpg";